import { render, staticRenderFns } from "./resultunit-landing-page.vue?vue&type=template&id=1a12c566&scoped=true"
import script from "./resultunit-landing-page.vue?vue&type=script&lang=js"
export * from "./resultunit-landing-page.vue?vue&type=script&lang=js"
import style0 from "./resultunit-landing-page.vue?vue&type=style&index=0&id=1a12c566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12c566",
  null
  
)

export default component.exports